import { cn } from '@/utils/cn'
import type { HTMLAttributes } from 'react'

export const LoadingBar = ({ className, ...props }: HTMLAttributes<HTMLDivElement>) => {
  return (
    <div
      className={cn('repeat-infinite h-1 w-full origin-left animate-loader-scale bg-accent duration-2000', className)}
      {...props}
    />
  )
}
